var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('div',{staticClass:"uncopyable",staticStyle:{"width":"100%","height":"100%"},attrs:{"id":"app","data-app":""}},[_c('router-view',{scopedSlots:_vm._u([{key:"default",fn:function({}){return undefined}}])})],1),(_vm.includedOnPages)?_c('div',[_c('div',{staticClass:"navbar-container"},[_c('nav-bar')],1)]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }